module.exports = __webpack_public_path__ + "static/media/program_step_3_fr.9d33efc9.svg";